import { observer } from "mobx-react"
import React from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import HyperDiv from "../../ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Unauthorized from "./../Images/Unauthorized"

const UnauthorizedAccessPage = observer(() => {
	const { t } = useTranslation()

	return (
		<UnauthorizedAccess>
			<HyperDiv width="100%" height="100%" centered>
				<HyperDiv centered direction="column" width="90%" className="text-center">
					<Unauthorized width="250px" height="270px" />
					<h1>{t("access.unauthorized-access")}</h1>
					<br />
					<p>{t("access.unauthorized-access-description")}</p>
				</HyperDiv>
			</HyperDiv>
		</UnauthorizedAccess>
	)
})

export default UnauthorizedAccessPage

const UnauthorizedAccess = styled.div`
	width: 100vw;
	height: 100vh;
	position: absolute;
	top: 0px;
	left: 0px;
	overflow-y: hidden;
	overflow-y: hidden;
	background-color: white;
	background: #fff; // Backup
`
